import React from "react";
import { useTranslation } from "react-i18next";
import formatMetric from "../util/formatMetric";
const InputThroughput = ({ metrics }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const {
    rate: { one_minute: oneMinute, five_minute: fiveMinute, fifteen_minute: fifteenMinute }
  } = metrics;
  return /* @__PURE__ */ React.createElement("div", { className: "graylog-input-metrics" }, /* @__PURE__ */ React.createElement("h3", null, t("input_throughput.heading")), /* @__PURE__ */ React.createElement("span", null, !Number.isNaN(oneMinute) && t("input_throughput.one_minute", { value: formatMetric(oneMinute) }), /* @__PURE__ */ React.createElement("br", null), !Number.isNaN(fiveMinute) && t("input_throughput.five_minute", { value: formatMetric(fiveMinute) }), /* @__PURE__ */ React.createElement("br", null), !Number.isNaN(fifteenMinute) && t("input_throughput.fifteen_minute", { value: formatMetric(fifteenMinute) })));
};
export default InputThroughput;
